import { memo, useMemo, useEffect } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { BzButton, BzTabs, BzTabsContainer, BzTab, BzTabsContent } from "../../../../components";
import Transactions from './Transactions';
import Mandate from './Mandate';
import SipDetails from './SipDetails';
import { useDispatch } from 'react-redux';
import { getMutualFundHoldings } from '../../../../redux/actions/mutualFund';


const HoldingSummary = ({ data: { mandate, sipDetails, transactions }, ...props }) => {
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(getMutualFundHoldings());
    }, [dispatch]);

    const myHoldingTypes = useMemo(() => [
        {
            id: 1,
            name: "Transaction",
            tabKey: 'transaction',
            tabContent: <Transactions transactions={transactions} />
        },
        {
            id: 2,
            name: "SIP Details",
            tabKey: 'sipDetails',
            tabContent: <SipDetails sipDetails={sipDetails} />
        },
        {
            id: 3,
            name: "Mandate",
            tabKey: 'mandate',
            tabContent: <Mandate mandate={mandate} />
        },
    ]);

    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col md={5} className='mrgauto'>
                        <Row className='g-0 my-3'>
                            <Col md={10} className='d-flex justify-content-start align-items-center'>
                                <div className='horizontal-scroll-wrap'>
                                    <BzTabs className='nav nav-tabs'>
                                        {
                                            myHoldingTypes?.map((holdingType) =>

                                                <BzTab key={holdingType?.id} tabKey={holdingType?.tabKey} isActive={holdingType.tabKey === "transaction"} tabContent={holdingType?.tabContent} className='nav-link text-capitalize'>
                                                    {holdingType?.name}
                                                </BzTab>
                                            )
                                        }
                                    </BzTabs>
                                </div>
                            </Col>
                            <Col md={2} className='d-flex justify-content-end align-items-center'>
                                <BzButton className='btn btn-sm btn-primary text-uppercase ms-3'>Transact</BzButton>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <BzTabsContainer>
                    {myHoldingTypes?.map((each) =>
                        <BzTabsContent key={each.id} showDefault={each.tabKey === "Transaction"} isActive={each.tabKey === "Transaction"} tabKey={each.tabKey}>
                            {each?.tabContent}
                        </BzTabsContent>
                    )
                    }
                </BzTabsContainer>
            </Container>
        </>
    );
};

export default memo(HoldingSummary);